import * as globalConstante from '../../../core/constantes';

export const globalConstantes = globalConstante;

export const columns = [
  {field: 'marque', header: 'Marque'},
  {field: 'couleur', header: 'Couleur'},
  {field: 'prix', header: 'Prix'},
];
